import ImmutableModel from '@aytm/lib/immutable/ImmutableModel'

import BlockModel from '@aytm/app/insights/dashboard/models/BlockModel'

import { BLOCK_TYPES } from '@aytm/app/insights/dashboard/lib/config'

class BlockTrackingValuesModel extends ImmutableModel({}, BlockModel) {
  static blockType = BLOCK_TYPES.TRACKING_VALUES
  static title = 'Tracking Values'
  static empty() {
    return BlockTrackingValuesModel.of().set('showChart', true)
  }
}
ImmutableModel.decorator({ name: 'BlockTrackingValuesModel', extends: BlockModel })(BlockTrackingValuesModel)
export default BlockTrackingValuesModel
